import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';
import Button from '../../../components/ui/Button';

const FilterSidebar = ({ 
  isOpen, 
  onClose, 
  filters, 
  onFilterChange, 
  onClearFilters,
  yards 
}) => {
  const unitTypeOptions = [
    { value: 'all', label: 'All Types' },
    { value: 'tractor', label: 'Tractor' },
    { value: 'trailer', label: 'Trailer' },
    { value: 'straight_truck', label: 'Straight Truck' },
    { value: 'van', label: 'Van' }
  ];

  const statusOptions = [
    { value: 'all', label: 'All Statuses' },
    { value: 'active', label: 'Active' },
    { value: 'maintenance', label: 'Maintenance' },
    { value: 'retired', label: 'Retired' },
    { value: 'available', label: 'Available' }
  ];

  const yardOptions = [
    { value: 'all', label: 'All Yards' },
    ...yards?.map(yard => ({
      value: yard?.id,
      label: yard?.name
    }))
  ];

  return (
    <>
      {isOpen && (
        <div 
          className="fixed inset-0 bg-background/80 backdrop-blur-sm z-[150] lg:hidden"
          onClick={onClose}
        />
      )}
      <aside 
        className={`
          fixed lg:sticky top-[7.5rem] left-0 h-[calc(100vh-7.5rem)] w-80 bg-card border-r border-border
          transition-transform duration-300 z-[160] lg:z-auto overflow-y-auto
          ${isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
        `}
      >
        <div className="p-6 space-y-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <Icon name="Filter" size={20} strokeWidth={2} className="text-primary" />
              <h2 className="text-lg font-semibold text-foreground">Filters</h2>
            </div>
            <button
              onClick={onClose}
              className="lg:hidden flex items-center justify-center w-8 h-8 text-muted-foreground hover:text-foreground hover:bg-muted/50 rounded-md transition-hover"
            >
              <Icon name="X" size={20} strokeWidth={2} />
            </button>
          </div>

          <div className="space-y-4">
            <Select
              label="Unit Type"
              options={unitTypeOptions}
              value={filters?.unitType}
              onChange={(value) => onFilterChange('unitType', value)}
            />

            <Select
              label="Status"
              options={statusOptions}
              value={filters?.status}
              onChange={(value) => onFilterChange('status', value)}
            />

            <Select
              label="Yard Location"
              options={yardOptions}
              value={filters?.yard}
              onChange={(value) => onFilterChange('yard', value)}
              searchable
            />

            <div className="pt-4 border-t border-border">
              <p className="text-sm font-medium text-foreground mb-3">Additional Filters</p>
              <div className="space-y-2">
                <Checkbox
                  label="Show only assigned units"
                  checked={filters?.onlyAssigned}
                  onChange={(e) => onFilterChange('onlyAssigned', e?.target?.checked)}
                />
                <Checkbox
                  label="Show units needing maintenance"
                  checked={filters?.needsMaintenance}
                  onChange={(e) => onFilterChange('needsMaintenance', e?.target?.checked)}
                />
                <Checkbox
                  label="Show high mileage units (>500k)"
                  checked={filters?.highMileage}
                  onChange={(e) => onFilterChange('highMileage', e?.target?.checked)}
                />
              </div>
            </div>
          </div>

          <Button
            variant="outline"
            fullWidth
            iconName="RotateCcw"
            iconPosition="left"
            onClick={onClearFilters}
          >
            Clear All Filters
          </Button>
        </div>
      </aside>
    </>
  );
};

export default FilterSidebar;